import * as React from 'react';

function CompasIcon(props) {
	return (
		<svg width={20} height={20} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 10 0Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm4.12-12.36a.49.49 0 0 0-.54-.11l-4.93 2a2 2 0 0 0-1.09 1.09l-2 4.93a.49.49 0 0 0 .11.54l.24.24a.49.49 0 0 0 .54.11l4.93-2a2 2 0 0 0 1.09-1.09l2-4.93a.49.49 0 0 0-.11-.54l-.24-.24Z'
				fill='#153c4f'
			/>
		</svg>
	);
}

export default CompasIcon;
